
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/entrenamientos",
      function () {
        return require("private-next-pages/entrenamientos/index.js");
      }
    ]);
  